export default "/images/dc283e1444e405db433963d3d7e53483.avif";